// store/modules/aideModule.ts
import { Module } from "vuex";
import { Aide, AideMode, AideState, ScaleBuisinessRuleSection } from "@/types";
import {
    aidesFilter,
    getAide,
    saveAide
} from "@/store/services/configuration/AideService";
import Notify from 'quasar/src/plugins/Notify.js';;
import i18n from "@/i18n";
import { deepClone } from "@/utils";
import store from "@/store";
import { getQcAides } from "@/store/services/filter/filterService";

const getStartAide = (): any => {
    return {
        systemUid: "odm-product",
        objectType: 'odm.product.productfeature.product.accessoryproduct.subsidyproduct',
        daaq: '/',
        reference: '',
        name: '',
        validity: {
            from: null,
            until: null
        },
        status: {
            objectType: 'odm.product.productstatus',
            systemUid: 'odm-product',
            resourceUid: 'USE'
        },
        aideResults: [{
            amount: "",
            amountMax: "",
            complexResultAmount: "",
            amountMin: "",
            annualRate: "",
            annualRateMax: "",
            annualRateMin: "",
            basis: "",
            calculationMethodOption: "",
            currency: ""
        }],
        accessoryProductRule: {
            ruleEngineId: null,
            rule: {
                label: "Business Rule 1",
                externalId: "businessRuleId",
                failIfNoResult: false,
                childInputHeader: [],
                childOutputHeader: [],
                childBusinessRuleItem: [],
                returnMultipleResults: true
            }
        }
    }
}

const aideModule: Module<AideState, unknown> = {
    namespaced: true,
    state: {
        isLoading: false,
        openAide: false,
        aide: getStartAide(),
        mode: AideMode.CREATE,
    },

    getters: {
        getAideObject: (state): Aide | undefined => {
            return state.aide;
        },
        getMode(state) {
            return state.mode;
        },
    },

    actions: {
        searchAide(context, payload) {
            const { filter, offset, limit, callback } = payload
            aidesFilter(filter, offset, limit)
                .then((response:any) => {
                    callback(response)
                })
                .catch((err:any) => console.error(err));
        },

        showAideDetail({ commit }) {
            commit("showAideDetail");
            commit('startAide');
        },

        saveAide(context) {
            if (context.state.aide) {
                context.commit("toggleIsLoading");
                saveAide(deepClone(context.state.aide)).then((res:any) => {
                    Notify.create({
                        message: i18n.global.t('main.dialog.success', { entity: res.resourceUid }),
                        color: 'positive'
                    })
                    context.commit("toggleIsLoading")
                    store.dispatch("releaseLockState")
                }).catch((err:any) => {
                    context.commit("toggleIsLoading")
                    console.error(err)
                    Notify.create({
                        message: `Error saving aide \n ${err}`,
                        color: 'negative'
                    });
                })
            }
        },

        getAide({ commit }, payload) {
            const { id, callback } = payload;
            getAide(id).then((res:any) => {
                commit('setAide', res);
                if (callback) {
                    callback(res)
                }
            }).catch((err:any) => {
                Notify.create({
                    message: `Error: \n ${err}`,
                    color: 'negative'
                });
            })
        },

        showAideDetailEdit({ commit }) {
            commit("showAideDetail");
        },

        cleanState({ commit }) {
            commit('cleanAide')
        },

        setMode({ commit }, payload) {
            commit("setMode", payload);
        }
    },

    mutations: {
        toggleIsLoading(state) {
            state.isLoading = !state.isLoading
        },

        showAideDetail(state) {
            state.openAide = !state.openAide;
        },

        startAide(state) {
            state.aide = getStartAide()
        },

        setAide(state, payload) {
            if ((store.state.queryBuilderModule.queryBuilder[ScaleBuisinessRuleSection.AIDE as any] as any)?.selectedBuisinessRule?.returnMultipleResults) {
                state.aide = payload;
            }
        },

        cleanAide(state) {
            state.isLoading = false
            state.aide = getStartAide()
        },

        setMode(state, payload) {
            state.mode = payload;
        }
    }
}

export default aideModule;